// extracted by mini-css-extract-plugin
export default {"container":"record__container___zWPuS","record":"record__record___MX9VR","splitter":"record__splitter___NibGT","newRecordCreated":"record__newRecordCreated___WkT__"};